( function( global, $ ) {

    $('[gr-gallery]').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '[gr-gallery-nav]'
    });

    $('[gr-gallery-nav]').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: '[gr-gallery]',
        prevArrow: '<button class="slider__arrow slider__arrow--secondary slider__prev" type="button" aria-label="Previous"></button>',
        nextArrow: '<button class="slider__arrow slider__arrow--secondary slider__next" type="button" aria-label="Next"></button>',
        responsive:
        [
            {
                breakpoint: parseInt(window.groots.sassBreakpoints['lg'], 10),
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: parseInt(window.groots.sassBreakpoints['md'], 10),
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: parseInt(window.groots.sassBreakpoints['sm'], 10),
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: parseInt(window.groots.sassBreakpoints['xs'], 10),
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

}( window.groots, jQuery, require('slick-carousel') ));
